﻿import * as React from 'react';

import { FormControl, InputGroup, Modal, Spinner, Table } from 'react-bootstrap';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { FormattedMessage, useIntl } from 'react-intl';
import { Api } from 'pages/students/pages/merge/Api';
import { useSuperState } from 'hooks';
import { Student } from 'types';

import 'pages/students/pages/merge/styles/index.scss';

interface Props {
    keep: boolean;
    setKeepAccount: Function;
    setMergeAccount: Function;
    setShow: Function;
    show: boolean;
}

const FindStudentModal = (props: Props) => {

    const { formatMessage } = useIntl();

    const [state, setState] = useSuperState({
        firstName: '',
        lastName: '',
        loading: false,
        searchResults: undefined as Student[] | undefined,
        username: ''
    });

    const handleClose = () => {

        setState({ firstName: '', lastName: '', searchResults: undefined, username: '' });
        props.setShow(false);

    };

    const applySearch = async (fn: string, ln: string, un: string) => {

        setState({ loading: true });
        try {

            const res = await Api.LookUpStudent(fn, ln, un);
            setState({ loading: false, searchResults: res });

        } catch {

            setState({ loading: false });

        }

    };

    const selectStudent = (index: number) => {

        if (state.searchResults) {

            const student: Student = state.searchResults[index];
            if (props.keep) {

                props.setKeepAccount(student);

            } else {

                props.setMergeAccount(student);

            }
            handleClose();

        }

    };

    return (
        <>
            <Modal onHide={handleClose} show={props.show} size={ state.searchResults ? 'xl' : undefined }>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {props.keep ? <FormattedMessage defaultMessage="Search Students to Keep" id="search_students_to_keep.4e48e06f" /> : <FormattedMessage defaultMessage="Search Students to Merge" id="search_students_to_merge.06ff0a87" />}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {
                        state.loading ? (
                            <Spinner animation="border" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} variant="primary" >
                                <span className="visually-hidden">
                                    <FormattedMessage defaultMessage="Loading..." description="Mensaje" id="loading.6f38d7c8" />
                                </span>
                            </Spinner>
                        ) : state.searchResults ? (
                            <>
                                <GMetrixButton onClick={() => setState({ searchResults: undefined })} style={{ marginBottom: 5 }} variant="primary">
                                    <FormattedMessage defaultMessage="Back" description="botones" id="back.2bdafbc4" />
                                </GMetrixButton>
                                <div className="sticky-table-scroll">
                                    <Table className="border sticky-table-header">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <FormattedMessage defaultMessage="First Name" id="first_name.759a675b" />
                                                </th>
                                                <th>
                                                    <FormattedMessage defaultMessage="Last Name" id="last_name.029e7273" />
                                                </th>
                                                <th>
                                                    <FormattedMessage defaultMessage="Username" id="username.dceab582" />
                                                </th>
                                                <th>
                                                    <FormattedMessage defaultMessage="Email" description="Formulario" id="email.5cbb5845" />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                state.searchResults.map((item: Student, index: number) => {

                                                    const tableRow = (
                                                        <tr key={'row' + index} onClick={() => selectStudent(index) } style={{ cursor: 'pointer' }}>
                                                            <td>
                                                                { item.FirstName }
                                                            </td>
                                                            <td>
                                                                { item.LastName }
                                                            </td>
                                                            <td>
                                                                { item.UserName }
                                                            </td>
                                                            <td>
                                                                {item.EmailAddress}
                                                            </td>
                                                        </tr>
                                                    );
                                                    return tableRow;

                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            </>
                        ) : (
                            <>
                                <InputGroup className="mb-3" size="sm">
                                    <InputGroup.Text id="inputGroup-sizing-md">
                                        <FormattedMessage defaultMessage="First Name" id="first_name.759a675b" />
                                    </InputGroup.Text>
                                    <FormControl aria-describedby="inputGroup-sizing-sm" aria-label={formatMessage({ id: 'small.8c7b92b3', defaultMessage: 'Small' })} onChange={event => setState({ firstName: event.target.value })} value={state.firstName} />
                                </InputGroup>

                                <InputGroup className="mb-3" size="sm">
                                    <InputGroup.Text id="inputGroup-sizing-md">
                                        <FormattedMessage defaultMessage="Last Name" id="last_name.029e7273" />
                                    </InputGroup.Text>
                                    <FormControl aria-describedby="inputGroup-sizing-sm" aria-label={formatMessage({ id: 'small.8c7b92b3', defaultMessage: 'Small' })} onChange={event => setState({ lastName: event.target.value })} value={state.lastName} />
                                </InputGroup>

                                <InputGroup className="mb-3" size="sm">
                                    <InputGroup.Text id="inputGroup-sizing-md">
                                        <FormattedMessage defaultMessage="Email/Username" id="emailusername.a26a2997" />
                                    </InputGroup.Text>
                                    <FormControl aria-describedby="inputGroup-sizing-sm" aria-label={formatMessage({ id: 'small.8c7b92b3', defaultMessage: 'Small' })} onChange={event => setState({ username: event.target.value })} value={state.username} />
                                </InputGroup>
                            </>
                        )
                    }

                </Modal.Body>
                <Modal.Footer>
                    <GMetrixButton onClick={handleClose} variant="secondary">
                        <FormattedMessage defaultMessage="Close" id="close.99e01fb5" />
                    </GMetrixButton>
                    {!state.searchResults && !state.loading && (
                    <GMetrixButton onClick={() => applySearch(state.firstName, state.lastName, state.username)} variant="primary">
                        <FormattedMessage defaultMessage="Search" id="search.0ab06b2c" />
                    </GMetrixButton>
                    )}

                </Modal.Footer>
            </Modal>
        </>
    );

};

export { FindStudentModal };